import type { ClosingStatus, LeadPipelineStageCategory } from './types';

export const STAGE_CATEGORY_LABELS: Record<LeadPipelineStageCategory, string> = {
  1: 'Open',
  2: 'Closed',
};

export const CLOSING_OUTCOME_LABELS: Record<Exclude<ClosingStatus, 0>, string> = {
  2: 'Won',
  3: 'Lost',
  4: 'Disqualified',
};

export const STAGE_CATEGORY_OPTIONS = Object.entries(STAGE_CATEGORY_LABELS).map(([value, label]) => ({
  value: Number(value) as LeadPipelineStageCategory,
  label,
}));

export const CLOSING_OUTCOME_OPTIONS = Object.entries(CLOSING_OUTCOME_LABELS).map(([value, label]) => ({
  value: Number(value) as Exclude<ClosingStatus, 0>,
  label,
}));
